<template>
  <v-row>
    <span v-if="itemData.isExtra">
      <v-icon color="yellow darken-2" left>mdi-star</v-icon
      >{{ itemData.boardBasis }} ({{ itemData.serviceName }})
    </span>
    <span v-else>{{ itemData.serviceName }}</span>
    <from-departure-icon v-if="itemData.fromDeparture" />
  </v-row>
</template>

<script>
import FromDepartureIcon from "../FromDepartureIcon.vue";

export default {
  name: "serviceName-label",

  components: { FromDepartureIcon },

  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    itemData() {
      return this.params ? { ...this.params.data } : { ...this.item };
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/labels/ServiceNameLabel.vue